<template>
  <div class=" mobile full-width">
    <div v-if="conditionNavBar" class="header-mobile">
      <NavBarHomePage :object-data="objectData" />
    </div>
    <div v-else class="header-mobile">
      <div
        v-if="getToken().bank_id == SOURCE_BANK.BIDV"
        style="flex-shrink: 0; width:20px; "
        class="mr-10"
        @click="handleBack"
      >
        <img src="@/assets/img/v3/img/arrow_left.png" alt="" />
      </div>
      <div
        v-else
        style="flex-shrink: 0; width:20px; "
        class="mr-10"
        @click="handleBack"
      >
        <img :src="icons.ArrowLeftIcon" alt="" />
      </div>

      <marquee v-if="objectData.title.length > 35">
        <p class="title-page p-0 m-0">{{ objectData?.title }}</p>
      </marquee>
      <div class="p-0 m-0 text-center" v-else>
        <p class="title-page p-0 m-0">
          {{ objectData?.title }}
        </p>
        <p v-if="objectData?.otherTitle" class="m-0 p-0 title-other">
          {{ objectData?.otherTitle }}
        </p>
      </div>
      <div
        @click="
          $router.push(
            $route.path.includes('list-tee-time')
              ? `/wap/detail-facilities/${objectData?.id}`
              : '/wap'
          )
        "
        style="flex-shrink: 0; "
        class="ml-10"
      >
        <img
          v-if="$route.path.includes('list-tee-time')"
          :src="icons.LightBulb"
          alt=""
        />
        <img v-else-if="objectData.isShowHomeIcon" :src="bg.icon_home" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import { getToken } from "@/utils/auth.js";
import ArrowLeftIcon from "@/assets/img/svg/arrow-left-icon.svg";
import HomeIcon from "@/assets/img/svg/home-icon.svg";
import LightBulb from "@/assets/img/svg/light-bulb.svg";
import { getBackGround } from "@/utils/wapAuth";
import NavBarHomePage from "@/layout/WapV2/NavBarHomePage.vue";
import { mapGetters } from "vuex";
import { SOURCE_BANK } from "@/constant/contant";

export default {
  components: {
    NavBarHomePage
  },
  props: {
    objectData: {
      type: Object,
      default() {
        return {};
      }
    },
    logo: {
      default: require("@/assets/img/logo/W_Booking_white.png")
    }
  },
  data() {
    return {
      SOURCE_BANK: SOURCE_BANK,
      bg: getBackGround(),
      extraNavClasses: "",
      toggledClass: false,
      admin: getToken(),
      images: {},
      icons: {
        ArrowLeftIcon,
        HomeIcon,
        LightBulb
      }
    };
  },
  created() {},
  computed: {
    ...mapGetters(["isShowOtp"]),
    conditionNavBar() {
      return this.$route.name === "homepage" && !this.isShowOtp;
    }
  },
  methods: {
    getToken,
    handleBack() {
      if (this.objectData.path) {
        this.$router.push(this.objectData.path);
        return;
      }
      if (this.objectData.isShowMenu) {
        this.$store.dispatch("setShowMenuApp", true);
        if (this.$route.name === "homepage") return;
        setTimeout(() => {
          this.$router.push("/wap");
        }, 200);
        return;
      }
      if (this.objectData.isDialog) {
        this.$store.dispatch("hideOtpDialog");
      } else {
        this.$router.go(this.objectData.routerGo || -1);
      }
    },
    handleResize() {
      // Xử lý khi chiều rộng màn hình thay đổi
      const windowWidth = window.innerWidth;
      if (windowWidth <= 991) {
        this.extraNavClasses = "";
      } else {
        this.extraNavClasses = `md-white`;
      }
    }
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  }
};
</script>

<style scoped>
.title-other {
  line-height: 1.1;
  margin: 0;
  color: #505c69;
  font-size: 12px;
  transform: translateY(-3px);
}
.mobile {
  display: none;
}
.pc {
  display: block;
}
.lang-mobile {
  background: v-bind("bg.c_header") !important ;
  display: none;
}
.md-list-item .md-list-item-content p {
  color: v-bind("bg.c_menu_header");
  font-weight: 500;
}

.white-color {
  color: v-bind("bg.c_menu_header");
}

@media screen and (min-width: 0px) and (max-width: 991px) {
  .title-page {
    font-weight: 600;
    color: black;
    font-size: 17px;
  }

  .header-mobile {
    display: flex !important;
    justify-content: space-between;
    align-items: center;
  }
  .lang-mobile {
    background: #0000 !important ;
    display: block;
    padding-left: 25px;
  }
  .lang-pc {
    display: none;
  }
  .mobile {
    display: block;
  }
  .pc {
    display: none;
  }
}
</style>
